"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actions = {
    EMIT_EVENT: 'EMIT_EVENT'
};
exports.actionCreators = {
    emitEvent: (event, payload) => ({
        type: exports.actions.EMIT_EVENT,
        event,
        payload
    })
};



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-website-events/src/actionCreators.ts